import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetByEpinPurchaseId } from '../../service/EpinService';

export default function EpinList() {
  const {
    isLoading, setIsLoading,
    setAppError, setAppErrorTitle, setAppErrorMessage, setAppErrorMode, appUser
  } = useGlobalContext();

  const { epinPurchaseId } = useParams();
  const [epins, setEpins] = useState([]);
  const [keyword, setKeyword] = useState('');

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const fetchEpinList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetByEpinPurchaseId(epinPurchaseId, currentPage, limit, keyword);
      setEpins(response.epins || []);
      setTotalPages(response.totalPages || 1); // Ensure your backend returns totalPages
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEpinList(page);
  }, [page]);

  const handleSearch = () => {
    setPage(1);
    fetchEpinList(1);
  };

  return (
    <>
      <Helmet>
        <title>Epin List | {config.appName}</title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>My Epin List</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/epinPurchase/list"> Epin Purchase List </Link> / My Epin Manage
            </span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <form>
                  <div className='row'>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Keyword</label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control"
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                          />
                          <button className="btn btn-outline-secondary" type="button" onClick={handleSearch}>
                            <FontAwesomeIcon icon="fa-solid fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div className='table-content'>
                   <div  className="mobile-scroll">
                  <table className='table table-bordered table-condensed'>
                    <thead>
                      <tr>
                        <th>Sl.no</th>
                        <th>Created Date Time</th>
                        <th>Code</th>
                        <th>Status</th>
                        <th>Used Member</th>
                        <th className="d-none">Purchased Member</th>
                      </tr>
                    </thead>
                    <tbody>
                      {epins && epins.length > 0 ? (
                        epins.map((epin, index) => (
                          <tr key={epin.id}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td>
                              {epin.createdDateTime && (() => {
                                const date = new Date(epin.createdDateTime);
                                const day = String(date.getDate()).padStart(2, '0');
                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                const year = date.getFullYear();
                                let hours = date.getHours();
                                const minutes = String(date.getMinutes()).padStart(2, '0');
                                const ampm = hours >= 12 ? 'PM' : 'AM';
                                hours = hours % 12 || 12;
                                return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
                              })()}
                            </td>
                            <td>{epin.code}</td>
                            <td>{epin.status}</td>

                            {/* Used Member Name (only show if used) */}
                            <td>{epin.status === 'used' ? epin.user?.name ?? '' : 'Not Yet'}</td>

                            {/* Purchased Member Name */}
                            <td  className="d-none">
                              {epin.epinPurchase?.user?.name ?? ''}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">No EPINs found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  </div>
                </div>

                {/* Pagination Controls */}
                <div className="pagination-buttons">
                  {page > 1 && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    >
                      Prev
                    </button>
                  )}

                  <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                  {page < totalPages && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                    >
                      Next
                    </button>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
